module.exports = __webpack_public_path__ + "img/9.2577a013.webp";